import { render } from "./report-adjustment.vue?vue&type=template&id=2f63d9bc"
import script from "./report-adjustment.vue?vue&type=script&lang=js"
export * from "./report-adjustment.vue?vue&type=script&lang=js"

import "./report-adjustment.vue?vue&type=style&index=0&id=2f63d9bc&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__